import {DocumentShort} from "../models/DocumentOfReceive";
import {PreviewMercantileNewInputTemplateData} from "./PreviewMercantileNewInputTemplateData";
import {PreviewMercantileNewInputImportTemplate} from "./PreviewMercantileNewInputImportTemplate";
import {cloneDeep} from "lodash";

export const getPreviewMercantileNewInputTemplate = (
    documentsOfImport: DocumentShort[],
    selectedWarehouse: string,
    selectedProduct: string,
    selectedProductCategory: string,
    dateFrom: Date,
    dateTo: Date,
    nettoSum: number,
    srpsSum: number,
    isImport: boolean
    ) => {
    return PreviewMercantileNewInputImportTemplate(prepareData(
        documentsOfImport.sort((a: DocumentShort, b: DocumentShort) => {
            return (new Date(a?.date as Date)).getTime() < (new Date(b?.date as Date)).getTime() ? 1 : -1}),
        selectedWarehouse,
        selectedProduct,
        selectedProductCategory,
        dateFrom,
        dateTo,
        nettoSum,
        srpsSum,
        isImport
    ));
};

const prepareData = (
    documentsOfImport: DocumentShort[],
    selectedWarehouse: string,
    selectedProduct: string,
    selectedProductCategory: string,
    dateFrom: Date,
    dateTo: Date,
    nettoSum: number,
    srpsSum: number,
    isImport: boolean
    ) => {
    const templateData: PreviewMercantileNewInputTemplateData = {
        documentsOfImport: cloneDeep(documentsOfImport),
        selectedWarehouse: selectedWarehouse ?? (isImport ? 'sve magacine' : 'svih magacina'),
        selectedProduct: selectedProduct ?? '',
        selectedProductCategory: selectedProductCategory != '' ? selectedProductCategory : 'sve kategorije proizvoda',
        dateFrom: dateFrom,
        dateTo: dateTo,
        nettoSum: nettoSum,
        srpsSum: srpsSum,
        isImport: isImport
    };

    return templateData;
};